module.exports = __webpack_public_path__ + "img/card-background-1.94bf68e.webp";